// LIBRERIE
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faLinkedin } from '@fortawesome/free-brands-svg-icons';

//CONFIGURAZIONI
import appConfig from "../../config/appConfig";

const SocialPost: React.FC = () => {

    return(
        <section id="social-post" className="space-ptb">
            <div className="container">
                <h3 className="asH2SubTitle mb-4 mb-lg-5 text-center">Seguimi sui social per non perderti il meglio</h3>
                <div className="row justify-content-center align-items-center">
                    <div className="col-12 col-sm-10 col-lg-6">
                        {/* Snap Widget */}
                        <div id="snap-widget-wrapper">
                            <script src="https://snapwidget.com/js/snapwidget.js"></script>
                            <iframe src="https://snapwidget.com/embed/1103508" className="snapwidget-widget" {...{ allowtransparency: 'true' } as any} scrolling="no" style={{border:"none", overflow:"hidden",  width:"100%", height:"550px"}} title="Posts di Instagram"></iframe>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <img className="d-none d-lg-block w-50 m-auto" src="/assets/images/logo.png" alt="logo" />
                        <p className="mt-4 mt-lg-5 text-center">Segui i miei <strong>canali social</strong> per scoprire in anteprima nuove proposte immobiliari, consigli utili per vendere o acquistare casa, storie di successo e aggiornamenti dal mercato. Rimani sempre aggiornato e vivi il mondo immobiliare da un punto di vista diretto e trasparente!</p>
                        <div className="social-list mt-3 mt-lg-5">
                            <a href={appConfig.socialLinks.instagram} title="Instagram Link">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                            <a href={appConfig.socialLinks.facebook} title="Facebook Link">
                                <i><FontAwesomeIcon icon={faFacebookF} /></i>
                            </a>
                            <a href={appConfig.socialLinks.linkedin} title="Linkedin Link">
                                <i><FontAwesomeIcon icon={faLinkedin} /></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SocialPost;